import React from 'react';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';
import VideoContentOptions from 'components/elements/pages/video/seriesContent/VideoContentOptions';

import './SeriesCatalogList.scss';

const SeriesCatalogList = (props) => {
  const { series, isContentPage } = props;
  const linkBasePath = `/videos${isContentPage ? '' : '/series/content'}`;

  const items = series.map((item, index) => (
    <div key={item.id || `series-list-${index}`} className="series-catalog-list--item">
      <Link to={`${linkBasePath}/${item.id}`}>
        <img src={item.img} alt={item.title} />
      </Link>
      <div className="series-catalog-list--item-title">
        <Link to={`${linkBasePath}/${item.id}`}>{ item.title }</Link>
      </div>
      { !isContentPage && <div className="series-catalog-list--item-summary">{item.summary}</div> }
      {
        isContentPage
        && <React.Fragment>
          <div className="series-catalog-list--item-summary">
            <Truncate lines={3} ellipsis={'...'}>{item.summary}</Truncate>
          </div>
          <VideoContentOptions {...item} />
        </React.Fragment>
      }
    </div>
  ));

  return (
    <div className="series-catalog-list">
      { items }
    </div>
  );
};

export default SeriesCatalogList;
